<template>
  <CustomUpdateDialog
    okTitle="بله"
    dialogTitle="ویرایش قیمت ده دقیقه تماس"
    dialogId="edit-call-price-confirmation-modal"
    :isOkDisabled="isOkButtonDisabled"
    @ok="updateCallPrice"
  >
    <div class="w-100 d-flex align-items-center" style="gap: 2rem">
      <p>آیا از تغییر قیمت ده دقیقه تماس اطمینان دارید؟</p>
    </div>
  </CustomUpdateDialog>
</template>
<script>
export default {
  props: {
    isOkButtonDisabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["updateCallPrice"],
  methods: {
    updateCallPrice() {
      this.$emit("updateCallPrice");
    },
  },
  components: {
    CustomUpdateDialog,
  },
};
import CustomUpdateDialog from "@/views/components/Utils/Dialogs/CustomUpdateDialog.vue";
</script>
